module.exports = __webpack_public_path__ + "staticVue/img/customer.98d02093.png";